import dialogPolyfill from "dialog-polyfill";

function getCookie(name) {
  let value = "; " + document.cookie;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
}

document.querySelectorAll("dialog.dialog").forEach((dialog) => {
  if (dialog) {
    const closeBtn = dialog.querySelector(".dialog-close");
    const cookieName = dialog.dataset.cookieName;
    const cookieDays = parseInt(dialog.dataset.cookieDays, 10) || 1;

    dialogPolyfill.registerDialog(dialog);

    const maxAge = 60 * 60 * 24 * cookieDays;

    const hasSeenPopup = getCookie(cookieName);

    if (!hasSeenPopup) {
      dialog.showModal();
    } else {
      dialog.close();
    }

    closeBtn.addEventListener("click", () => {
      document.cookie = `${cookieName}=true; max-age=${maxAge}; path=/`;
      dialog.close();
    });
  }
});
